import { css } from '@emotion/react';

export const listBase = css`
  box-sizing: border-box;
  list-style: none;
  position: relative;
  width: 100%;
`;
